export default "__VITE_ASSET__BtriQ9NN__"